import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { profile } from '../content';
import { analytics } from '../../utils/analytics';

export const Footer = () => {
    return (
        <>
            <section id="contacto" className="contact-band" aria-labelledby="contact-title">
              <div className="container contact-row">
                <div><p className="eyebrow">Contacto profesional</p><h2>Conversemos sobre<br />tu próximo reto.</h2><p>Modernización de sistemas, desarrollo de producto o una conversación técnica sobre tu proyecto.</p></div>
                <div className="contact-links">
                  <a href={profile.whatsapp} target="_blank" rel="noopener noreferrer" className="button primary" onClick={() => analytics.trackContactClick('footer')}>Conversar por WhatsApp <FontAwesomeIcon icon={faArrowRight} /></a>
                  <a href={`mailto:${profile.email}`}><FontAwesomeIcon icon={faEnvelope} /> {profile.email}</a>
                </div>
              </div>
            </section>
            <footer className="footer__app">
              <div className="container footer-row">
                <p>© {new Date().getFullYear()} Ray Saracual Carrera</p>
                <nav className="footer-nav" aria-label="Enlaces profesionales">
                  <a href={profile.github} target="_blank" rel="noopener noreferrer" onClick={() => analytics.trackExternalLink('GitHub', profile.github)}>GitHub</a>
                  <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" onClick={() => analytics.trackExternalLink('LinkedIn', profile.linkedin)}>LinkedIn</a>
                  <Link to="/privacy">Privacidad</Link>
                </nav>
              </div>
            </footer>
        </>
    )
}




